(function () {
  var ytApiLoaded = false;

  function loadYouTubeAPI() {
    if (ytApiLoaded) return;
    ytApiLoaded = true;
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }

  // Only wire up deferred videos
  document.querySelectorAll('[data-video-defer]').forEach(function (container) {
    var playBtn = container.querySelector('.video-container__play');
    if (!playBtn) return;

    // On first interaction with the play button, load YouTube API
    playBtn.addEventListener('click', function onFirstPlay() {
      loadYouTubeAPI();
      playBtn.removeEventListener('click', onFirstPlay);
    }, { once: true });

    // Also preload on hover — feels instant to the user
    container.addEventListener('mouseenter', function onHover() {
      loadYouTubeAPI();
      container.removeEventListener('mouseenter', onHover);
    }, { once: true });
  });
})();